@switch (item.columnType) {
  @case ("STRING") {
    {{ row[item.valueKey] }}
  }
  @case ("NUMBER") {
    {{ (row[item.valueKey] | number: "1.2-2") || "0" | removeTrailingZeros }}
  }
  @case ("INT_NUMBER") {
    {{ row[item.valueKey] | number: "1.0-0" }}
  }
  @case ("CURRENCY_DOLLAR") {
    {{ (row[item.valueKey] | currency: "USD") || "0" | removeTrailingZeros }}
  }
  @case ("CURRENCY_INR") {
    {{ (row[item.valueKey] | currency: "INR") || "0" | removeTrailingZeros }}
  }
  @case ("DATE") {
    {{ row[item.valueKey] | date: "dd-MM-yyyy" }}
  }
  @case ("DATE_TIME") {
    {{ row[item.valueKey] | date: "dd-MM-yyyy h:mm:ss a" }}
  }
  @case ("CHECK_BOX") {
    @if (row[item.valueKey]) {
      <span class="text-yes text-green">Yes</span>
    }
    @if (!row[item.valueKey]) {
      <span class="text-no text-error">No</span>
    }
  }
  @case ("FUNCTION") {
    {{ row | TableRow: item.valueKey }}
  }
  @case ("HTML") {
    <div [innerHTML]="row[item.valueKey] | sanitizer: 'html'"></div>
  }
  @case ("IMAGE") {
    <img height="50" width="50" [src]="row[item.valueKey]" />
  }
}
